module.exports = __webpack_public_path__ + "assets/img/b4-4.e07bb178.png";